export const leadSources = [
  'Website',
  'Referral',
  'Social Media',
  'Email Campaign',
  'Cold Call',
  'Trade Show',
  'Other',
];
export interface LeadData {
  name: string;
  email: string;
  phone: string;
  source: string;
  status: 'New' | 'Contacted' | 'Qualified' | 'Proposal' | 'Converted' | 'Lost';
  assignedTo: string;
  value: number;
  notes: string;
  company: string;
  position: string;
}
export const leadStatuses: LeadData['status'][] = [
  'New',
  'Contacted',
  'Qualified',
  'Proposal',
  'Converted',
  'Lost',
];
export const assignees = [
  'Sarah Johnson',
  'Mike Wilson',
  'Emily Davis',
  'Robert Brown',
];
